<template>
  <div>
    <v-snackbar
      v-for="(message, index) in queueMessages.slice(0, maximumNotifications)"
      :key="'message_' + message.uid"
      class="px-0 py-0"
      :style="{ 'margin-top': 105 * index + 'px' }"
      :value="true"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :color="message.color"
      @input="hideNotification(index)"
    >
      <div class="snackbar-content">
        <v-btn class="mr-4" fab elevation="0" :color="message.color" @click="hideNotification(index)">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>

        <div class="v-card v-card--no-style">
          <div class="v-card-h2">{{ message.message.title }}</div>

          <div v-if="message.message.messages" class="v-card-h3 mt-1">
            <div v-for="(msg, innerIndex) in message.messages" :key="'message_' + message.uid + '_' + innerIndex">
              {{ msg }}
            </div>
          </div>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    x: {
      type: String,
      default: 'right'
    },
    y: {
      type: String,
      default: 'top'
    },
    timeout: {
      type: Number,
      default: 8000
    }
  },
  data() {
    return { maximumNotifications: Math.round(window.innerHeight / 105) - 3 };
  },
  computed: {
    ...mapGetters(['countMessages', 'queueMessages'])
  },
  methods: {
    // @vuese
    // Funkcja zamykająca wszystkie powiadomienia
    closeAll() {
      this.$store.dispatch('clearAll');
    },
    // @vuese
    // Funkcja zamykająca wybrane powiadomienie
    // @arg index - index powiadomienia;
    hideNotification(index) {
      this.$store.dispatch('hideNotification', index);
    }
  }
};
</script>

<style>
#closeNotifcations {
  border-radius: 4px;
  margin-bottom: 6px;
  position: sticky;
  box-shadow: 0 0 3px #999999;
  color: #ffffff;
  float: right;
}
</style>
